<template>
  <yxt-drawer
    size="960px"
    :title="$t('pc_gwnl_global_modelSets')"
    :visible.sync="show"
    :before-close="beforeDrawClose"
  >
    <div class="yxtbiz-model-selector">
      <div class="flex">
        <attribute-selector
          v-model="selectedAttribute"
          :placeholder="$t('gwnl_gwnl_pc_model_attribute')"
          :list="attributeOptions"
          class="mr12"
          @change="search(1)"
        />
        <attribute-selector
          v-model="selectedApplication"
          :placeholder="$t('gwnl_gwnl_pc_model_hierarchical')"
          :list="applicationLevelOptions"
          class="mr12"
          @change="search(1)"
        />
        <yxt-input
          v-model="searchText"
          :placeholder="$t('pc_gwnl_jq_pleaseEnterLabelName', { prefixLabel: prefixLabel })"
          style="width: 240px;"
          size="small"
          class="mb16"
          searchable
          @search="search(1)"
          @keyup.enter.native="search(1)"
        />
      </div>
      <yxt-table
        ref="table"
        v-loading="loading"
        row-key="id"
        :data="list"
      >
        <yxt-table-column
          prop="name"
          min-width="300"
          :label="$t('pc_gwnl_model_template__table_column_name')"
        >
          <template slot-scope="{row}">
            <div
              class="gwnl__skill-name cursor-pointer"
            >
              <yxt-popover
                effect="dark"
                trigger="hover"
                popper-class="gwnl-jq-create-popper"
                placement="top"
                max-width="280"
                max-height="144"
                show-scroll
                :open-filter="true"
                :content="row.name"
              >
                <div
                  slot="reference"
                  style="max-width: 280px;"
                  class="ellipsis"
                >
                  {{ row.name||'--' }}
                </div>
              </yxt-popover>
              <yxt-tag
                v-if="row.cloudType"
                class="ml14"
                size="mini"
              >
                {{ $t('pc_gwnl_global_tag_cloud') }}
              </yxt-tag>
              <yxt-tag
                v-if="!row.enableSkillLevel"
                class="ml8"
                size="mini"
                type="warning"
              >
                {{ $t("pc_gwnl_global_tag_noLevel") }}
              </yxt-tag>
            </div>
          </template>
        </yxt-table-column>
        <yxt-table-column
          prop="attributeName"
          width="104"
          :label="$t('pc_gwnl_global_lbl_modelprop')"
        >
          <template slot-scope="{row}">
            {{ row.attributeName || '--' }}
          </template>
        </yxt-table-column>
        <yxt-table-column
          prop="hierarchicalName"
          min-width="90"
          show-overflow-tooltip
          :label="$t('gwnl_gwnl_pc_model_hierarchical')"
        >
          <template slot-scope="{row}">
            {{ row.hierarchicalName || '--' }}
          </template>
        </yxt-table-column>
        <yxt-table-column
          width="160px"
          :label="$t('pc_gwnl_global_lbl_operate')"
          fixed="right"
          hide-column="disable"
        >
          <template slot-scope="scope">
            <yxt-button
              type="text"
              @click="previewTemplate(scope.row.id)"
            >
              {{ $t('pc_gwnl_global_btn_preview') }}
            </yxt-button>
            <yxt-divider direction="vertical" />
            <yxt-button
              type="text"
              @click="toggleSelectTemplate(scope.row)"
            >
              {{ selectedId === scope.row.id ? $t('pc_gwnl_global_deselect') : $t('pc_gwnl_global_select') }}
            </yxt-button>
          </template>
        </yxt-table-column>
      </yxt-table>
      <div class="clearfix">
        <pager
          :pager="pager"
          @searchData="search"
        />
      </div>
    </div>
    <div slot="footer">
      <yxt-button
        plain
        @click="close"
      >
        {{ $t('pc_gwnl_global_msg_cancel') }}
      </yxt-button>
      <yxt-button
        type="primary"
        :disabled="!selectedId && type !== 2 && type !== 3"
        @click="handleConfirm"
      >
        {{ $t('pc_gwnl_global_msg_determine') }}
      </yxt-button>
    </div>
  </yxt-drawer>
</template>

<script>
import attributeSelector from './components/attributeSelector';
import pager from './components/pager';
import { getDictsOrg, checkSkillModel, getSkillModelList } from './service';
import drawerBeforeClose from './mixins/drawerBeforeClose.js';

export default {
  name: 'YxtbizModelSelector',
  components: {
    attributeSelector,
    pager
  },
  mixins: [drawerBeforeClose],
  props: {
    source: {
      type: Number,
      default: 1 // 1 自建 2 云端 -1 全部
    },
    defaultValue: {
      type: String,
      default: ''
    }, // 默认选中的值
    type: {
      type: Number,
      default: 0 // 0-岗位模型，1-认证模型，2-测评模型，3-通用模型 -1 全部
    },
    pageType: String
  },
  data() {
    return {
      show: false,
      selectedId: '',
      cloudType: false,
      loading: false,
      selectedApplication: '',
      selectedAttribute: '',
      searchText: '',
      list: [],
      prefixLabel: this.$t('pc_gwnl_model_template__title_name'),
      // 分页
      pager: {
        pages: 0,
        pageSize: 20,
        total: 0,
        limit: 0,
        offset: 0
      },
      modelType: '',
      modelTypes: {
        0: {
          label: this.$t('pc_gwnl_model_template__map_type'),
          value: 0
        },
        2: {
          label: this.$t('pc_gwnl_model_template__eval_type'),
          value: 2
        },
        4: {
          label: this.$t('pc_gwnl_model_template__talentrv_type'),
          value: 4
        }
      },
      attributeOptions: [],
      applicationLevelOptions: []
    };
  },
  computed: {
    catalogOptions() {
      switch (this.type) {
        case 2:
        case '2':
          return [
            this.modelTypes['0'],
            this.modelTypes['2'],
            this.modelTypes['4']
          ];
        case 0:
        case '0':
          return [this.modelTypes['0']];
        default:
          return [];
      }
    }
  },
  mounted() {
    this.getDictsOrgFn(1);
    this.getDictsOrgFn(2);
  },
  methods: {
    async getDictsOrgFn(type) {
      try {
        const res = await getDictsOrg({ type });
        const datas = res.datas;
        if (type === 2) {
          this.applicationLevelOptions = datas || [];
        } else {
          this.attributeOptions = datas || [];
        }
        if (!this.id) {
          this.templateBasic = {
            ...this.templateBasic,
            attribute: this.attributeOptions.length && this.attributeOptions[0].id,
            hierarchical: this.applicationLevelOptions.length && this.applicationLevelOptions[0].id
          };
        }
      } catch (err) {
        this.$message.error(err.error.message);
      }
    },
    init() {
      this.selectedId = this.defaultValue;
      this.saveOldData(this.selectedId);
      this.searchText = '';
    },
    open() {
      this.init();
      this.show = true;
      if (this.catalogOptions.length === 1) {
        // 如果只有一个类型，直接选中
        this.modelType = this.catalogOptions[0].value;
      }
      this.search(1);
    },
    close() {
      this.show = false;
    },
    toggleSelectTemplate(template) {
      this.selectedId = (this.selectedId === template.id) ? '' : template.id;
      this.cloudType = template.cloudType;
    },
    previewTemplate(id) {
      this.$emit('preview', id);
    },
    handleConfirm() {
      if ((this.type === 2 || this.type === 3) && !this.selectedId) {
        this.close();
        this.$emit('success', '');
        return;
      }

      checkSkillModel(this.selectedId).then(() => {
        this.close();
        this.$emit('success', this.selectedId, this.cloudType);
      }).catch(() => {
        this.showConfirmDialog();
      });
    },
    showConfirmDialog() {
      this.$confirm(
        this.$t('pc_gwnl_model_template_msg_skillListNeedRefresh'),
        this.$t('pc_gwnl_global_tips'),
        {
          confirmButtonText: this.$t('pc_gwnl_global_msg_determine'),
          cancelButtonText: this.$t('pc_gwnl_global_msg_cancel'),
          type: 'warning'
        }
      ).then(() => {
        this.search(1);
      }).catch((err) => {
        this.$message.error(err);
      }).finally(() => {
        this.selectedId = '';
      });
    },
    beforeDrawClose(done) {
      done(this.isDataChanged(this.selectedId));
    },
    async search(page) {
      if (this.loading) return;
      this.searchText = this.searchText.trim();
      const data = {
        auditStatus: 1,
        name: this.searchText,
        sourceType: this.source,
        attribute: this.selectedAttribute,
        hierarchical: this.selectedApplication,
        type: this.modelType,
        dataPermissionSwitch: -1,
        dataPermission: -1
      };
      try {
        this.loading = true;
        const res = await getSkillModelList(data, {
          limit: this.pager.pageSize,
          offset: page ? (page - 1) * this.pager.pageSize : this.pager.offset
        });
        this.pager.pages = res.paging.pages;
        this.pager.offset = res.paging.offset;
        this.pager.total = res.paging.count;
        this.list = res.datas || [];
        this.selectedId = this.defaultValue;
      } catch (err) {
        this.$message.error(err);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
